import { gql } from 'glimmer-apollo';

export const ESPORTS_MATCH_QUERY = gql`
  query ($slug: String) {
    match: match(slug: $slug) {
      title
      slug
      isLive
      isFinal
      bestOf
      scheduledDate
      tournament {
        isLive
        liveChatUrl
        liveVideoUrl
      }
      victor {
        name
        slug
        logo {
          url
        }
      }
      game {
        title
        slug
      }
      rounds {
        roundNumber
        isLive
        embedUrl
        victor {
          slug
        }
      }
      teams {
        name
        slug
        players {
          gamertag
          role
          slug
          photo {
            url
          }
        }
        logo {
          url
        }
      }
    }
  }
`;
